<template>
  <v-app>
    <v-container fluid class="pa-0">
      <v-form @submit.prevent="submit">
        <v-row>
          <v-col cols="12">
              <v-expansion-panels v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                    {{ isEntryMode ? 'Create B.O.M' : 'Update B.O.M' }}
                  </v-expansion-panel-title>

                  <v-expansion-panel-text>
                    <v-card flat>
                      <v-card-text>

                          <v-row dense>

                            <!-- STYLE -->
                            <v-col cols="12" md="4">
                              <v-select
                                v-model="style_id.value.value"
                                :items="styleList"
                                :item-title="item => item.code"
                                item-value="id"
                                label="Select Style *"
                                variant="outlined"
                                density="compact"
                                clearable
                                :error-messages="style_id.errorMessage.value"
                              />
                            </v-col>

                            <!-- VERSION -->
                            <v-col cols="12" md="4">
                              <v-text-field
                                v-model="version.value.value"
                                label="Version *"
                                variant="outlined"
                                density="compact"
                                clearable
                                :error-messages="version.errorMessage.value"
                              />
                            </v-col>

                          </v-row>
    
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
          </v-col>
          <v-col col="12">
              <v-row>
                <v-col cols="12" md="6">
                  <v-expansion-panels v-model="panel2" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                        Fabrics
                      </v-expansion-panel-title>

                      <v-expansion-panel-text>
                        <v-card flat>
                          <v-card-text>

                              <v-row dense>
                                <v-col cols="12" class="pb-0" v-for="(row, index) in fabrics.value.value":key="'fabric-' + index" >
                                    <v-row dense>
                                      <v-col md="5">
                                        <v-text-field
                                          v-model="row.fabric_type"
                                          label="Fabric Type *"
                                          variant="outlined"
                                          density="compact"
                                          :error-messages="getFabricError(index, 'fabric_type')"
                                        />
                                      </v-col>

                                      <v-col md="5">
                                        <v-text-field
                                          v-model="row.consumption"
                                          label="Consumption *"
                                          variant="outlined"
                                          density="compact"
                                          type="number"
                                          :error-messages="getFabricError(index, 'consumption')"
                                        />
                                      </v-col>

                                                                                    
                                      <v-col md="2" class="text-left">
                                        <v-btn v-if="index != trims.value.value.length - 1" icon variant="tonal" size="small" color="primary" class="pa-1" @click="removeFabric(index)">
                                          <v-icon color="red">mdi-close</v-icon>
                                        </v-btn>

                                        <v-btn v-if="index == fabrics.value.value.length - 1" variant="tonal" icon size="small" color="primary" @click="addFabric">
                                          <v-icon color="blue">mdi-plus</v-icon>
                                        </v-btn>
                                      </v-col>
                                    </v-row>
                                </v-col>
                              </v-row>

                            
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
                <v-col cols="12" md="6">
                  <v-expansion-panels v-model="panel3" multiple>
                    <v-expansion-panel>
                      <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                        Trims
                      </v-expansion-panel-title>

                      <v-expansion-panel-text>
                        <v-card flat>
                          <v-card-text>

                              <v-row dense>
                                <v-col cols="12">
                                  <v-col cols="12" class="pb-0" v-for="(row, index) in trims.value.value" :key="'trim-' + index" >
                                    <v-row dense>
                                      <v-col md="5">
                                        <v-text-field
                                          v-model="row.trim_name"
                                          label="Trim Name *"
                                          variant="outlined"
                                          density="compact"
                                          :error-messages="getTrimError(index, 'trim_name')"
                                        />
                                      </v-col>

                                      <v-col md="5">
                                        <v-text-field
                                          v-model="row.consumption"
                                          label="Consumption *"
                                          variant="outlined"
                                          density="compact"
                                          type="number"
                                          :error-messages="getTrimError(index, 'consumption')"
                                        />
                                      </v-col>

                                      <v-col md="2" class="text-left">

                                        <v-btn v-if="index != trims.value.value.length - 1" icon variant="tonal" size="small" color="primary" @click="removeTrim(index)">
                                          <v-icon color="red">mdi-close</v-icon>
                                        </v-btn>

                                        <v-btn v-if="index == trims.value.value.length - 1" variant="tonal" icon size="small" color="primary" @click="addTrim">
                                          <v-icon color="blue">mdi-plus</v-icon>
                                        </v-btn>

                                      </v-col>
                                    </v-row>
                                  </v-col>
                                </v-col>

                              </v-row>



                            
                          </v-card-text>
                        </v-card>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>

              <v-divider class=""></v-divider>
              <!-- ACTION BUTTONS -->
              <v-card-actions class="justify-end">
                <v-btn color="white" class="bg-grey-darken-1 me-2" @click="submitForm(0)">Draft</v-btn>
                <v-btn color="primary" variant="flat" type="button" @click="submitForm(1)" class="ms-2">
                  {{ isEntryMode ? 'Save BOM' : 'Update BOM' }}
                </v-btn>
              </v-card-actions>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </v-app>
</template>

<script>
import { ref, onMounted } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";
import { useRoute, useRouter } from "vue-router";

export default {
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const panel = ref([0]);
    const panel2 = ref([0]);
    const panel3 = ref([0]);
    const isEntryMode = ref(true);

    // LOAD DROPDOWN DATA
    store.dispatch("getProductionStyleList");

    // FORM SETUP
    const { handleSubmit, resetForm, setValues, setFieldValue, errors } = useForm({
      initialValues: {
        bom_id: null,
        style_id: null,
        version: "",
        fabrics: [{ fabric_type: "", consumption: "" }],
        trims: [{ trim_name: "", consumption: "" }],
      },
      validationSchema: yup.object({
        style_id: yup.number().required("Style is required"),
        version: yup.string().required("Version is required"),
        fabrics: yup.array().of(
          yup.object({
            fabric_type: yup.string().required("Fabric type is required"),
            consumption: yup
              .number()
              .typeError("Consumption must be a number")
              .positive("Consumption must be greater than 0")
              .required("Consumption is required"),
          })
        ),
        trims: yup.array().of(
          yup.object({
            trim_name: yup.string().required("Trim name is required"),
            consumption: yup
              .number()
              .typeError("Consumption must be a number")
              .positive("Consumption must be greater than 0")
              .required("Consumption is required"),
          })
        ),
      }),
    });

    const style_id = useField("style_id");
    const version = useField("version");
    const fabrics = useField("fabrics");
    const trims = useField("trims");

    // FABRIC/TRIM FUNCTIONS
    const addFabric = () => fabrics.value.value.push({ fabric_type: "", consumption: "" });
    const removeFabric = (i) => fabrics.value.value.splice(i, 1);

    const addTrim = () => trims.value.value.push({ trim_name: "", consumption: "" });
    const removeTrim = (i) => trims.value.value.splice(i, 1);

    // Helper functions for validation errors
    const getFabricError = (index, field) => {
      try {
        const errorKey = `fabrics.${index}.${field}`;
        if (errors.value[errorKey]) {
          return errors.value[errorKey];
        }
        // Try alternative path
        const fabricErrors = fabrics.value.meta.errors;
        if (fabricErrors && Array.isArray(fabricErrors) && fabricErrors[index] && fabricErrors[index][field]) {
          return fabricErrors[index][field];
        }
      } catch (e) {
        // Ignore errors
      }
      return "";
    };

    const getTrimError = (index, field) => {
      try {
        const errorKey = `trims.${index}.${field}`;
        if (errors.value[errorKey]) {
          return errors.value[errorKey];
        }
        // Try alternative path
        const trimErrors = trims.value.meta.errors;
        if (trimErrors && Array.isArray(trimErrors) && trimErrors[index] && trimErrors[index][field]) {
          return trimErrors[index][field];
        }
      } catch (e) {
        // Ignore errors
      }
      return "";
    };

    // EDIT MODE
    onMounted(() => {
      if (route.params.id) {
        const id = route.params.id;
        isEntryMode.value = false;

        setValues({ bom_id: id });

        store.dispatch("getProductionBomById", { id })
          .then((res) => {
            const data = res.data.data;

            setValues({
              bom_id: id,
              style_id: data.style.id,
              version: data.version,
              fabrics: data.fabrics,
              trims: data.trims,
            });
          })
          .catch(() => toast.error("Failed to load BOM"));
      }
    });

    const submitForm = (status) => {
      setFieldValue('status', status);
      submit();                       
    };

    // SUBMIT
    const submit = handleSubmit((values) => {
      const payload = {
        style_id: values.style_id,
        version: values.version,
        status: values.status,
        fabrics: values.fabrics,
        trims: values.trims,
      };

      if (values.bom_id) {
        store
          .dispatch("updateProductionBom", { id: values.bom_id, data: payload })
          .then(() => {
              toast.success("BOM Updated Successfully!");
              router.push({ name: "bom-records" });
          })
          .catch((err) => toast.error(err.response?.data?.message));
      } else {
        store
          .dispatch("saveProductionBom", payload)
          .then(() => {
            toast.success("BOM Created Successfully!");
            router.push({ name: "bom-records" });
          })
          .catch((err) => toast.error(err.response?.data?.message));
      }
    });

    return {
      panel,
      panel2,
      panel3,
      isEntryMode,
      submit,
      resetForm,
      style_id,
      version,
      fabrics,
      trims,
      addFabric,
      removeFabric,
      addTrim,
      removeTrim,
      submitForm,
      getFabricError,
      getTrimError,
      styleList: store.getters.getProductionStyleList,
    };
  },
};
</script>

<style scoped>
  .border-thick {
    border-width: 1px !important;
    color:#000;
  }
</style>
